<template>
  <div>
    <div class="importance-selection">
      <div class="title"><em>HOW HOPEFUL I FEEL FOR</em><em :style="{color: '#' + confirmingConcept.categoryObject.color.toString(16)}">{{confirmingConcept.label}}</em></div>

      <div class="left-side">
        <transition>
          <div class="desktop-intro" v-if="intro">
            HOW HOPEFUL<br>ARE YOU?
          </div>
        </transition>
        <transition>
          <div class="desktop-instructions" v-if="!intro">
            I FEEL<br><em>{{importanceDefinition}}</em><br>HOPEFUL
          </div>
        </transition>
      </div>

      <div class="definition">{{importanceDefinition}} HOPEFUL</div>

      <div class="track-container">
          <div class="minus el-icon-minus" />
          <div class="track" />
          <div class="plus el-icon-plus" />
      </div>
      <div class="importance-confirm-btns">
        <el-button class="cancel-btn secondary" @click="$emit('cancel')">remove</el-button>
        <el-button class="confirm-btn" @click="$emit('confirm')">CHOOSE</el-button>
      </div>
    </div>

    <div class="importance-confirm-btns mobile">
      <el-button class="cancel-btn secondary" @click="$emit('cancel')">remove</el-button>
      <el-button class="confirm-btn" @click="$emit('confirm')">CHOOSE</el-button>
    </div>
  </div>
</template>

<script>
import ConceptsSelectionWheel from '@/molecules/ConceptsSelectionWheel'
import Viewport from '@/mixins/Viewport'
import ElButton from 'element-ui/packages/button'
import delay from 'lodash/delay'

export default {
  name: 'ConceptImportanceUI',
  mixins: [Viewport],
  components: {
    ConceptsSelectionWheel,
    ElButton
  },
  data: function () {
    return {
      intro: true,
      definitions: ['A LITTLE', 'DEFINITELY', 'UNCONDITIONALLY']
    }
  },
  mounted: function () {
    this.introDelay = delay(() => {
      this.intro = false
    }, 4000)
  },
  watch: {
    'confirmingConcept.importance': function (value) {
      this.intro = false
    }
  },
  computed: {
    importanceDefinition: function () {
      let index = Math.round((this.definitions.length - 1) * this.confirmingConcept.importance)
      return this.definitions[index]
    }
  },
  props: {
    confirmingConcept: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';
@import 'mixins';

.importance-selection {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  -webkit-user-drag: none;
  user-select: none;

  @include breakpoint(#{$bp-sm}px) {
    top: inherit;
    height: #{$concept-selector-desktop-height}px;
    width: 100%;
    bottom: 0;
    left: 0;
    transform: none;
    // background: linear-gradient(to bottom, color-alpha($c-background, 0), $c-background, $c-background, $c-background);
  }
}

.title {
  text-transform: uppercase;
  text-align: center;
  line-height: 30px;
  color: color-alpha($c-black, 0.7);
  letter-spacing: 1px;
  text-align: center;
  position: absolute;
  top: 100px;
  width: 100%;
  em:nth-child(2) {
    letter-spacing: 1.5px;
    // white-space: nowrap;
    display: block;
    color: $c-black;
    font-size: 24px;
    margin-top: 0;

    @include breakpoint(#{$bp-sm}px) {
      display: none;
      margin-top: 10px;
    }
  }
  @include breakpoint(#{$bp-sm}px) {
    display: none;
  }
}

.importance-confirm-btns {
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  z-index: $z-ui;
  white-space: nowrap;

  display: none;

  &.mobile {
    display: block;
    
    @include breakpoint(#{$bp-sm}px) {
      display: none;
    }
  }

  .el-button {
    // pointer-events: all;
    text-transform: uppercase;
    width: 150px;
    @include breakpoint(#{$bp-sm}px) {
      position: relative;
      top: 50%;
      bottom: auto;
      transform: translate(0, -50%);
    }
  }
  @include breakpoint(#{$bp-sm}px) {
    display: block;
    left: auto;
    right: 0;
    height: #{$concept-selector-desktop-height}px;
    bottom: inherit;
    width: 32%;
    transform: translate(0, -50%);
    top: 50%;
    text-align: center;
    background: #f9f8f7; // linear-gradient(to bottom, color-alpha($c-background, 0), $c-background, $c-background, $c-background);
  }

  &.done {
    @include breakpoint(#{$bp-sm}px) {
      background: linear-gradient(to bottom, color-alpha($c-background, 0), $c-background, $c-background, $c-background);
    }
  }
}

.left-side {
  position: absolute;
  display: none;
  top: 50%;
  left: 0;
  width: 32%;
  height: #{$concept-selector-desktop-height}px;
  transform: translate(0, -50%);
  z-index: $z-ui;
  background: #f9f8f7; // linear-gradient(to bottom, color-alpha($c-background, 0), $c-background, $c-background, $c-background);

  @include breakpoint(#{$bp-sm}px) {
    display: block;
  }

  &.done {
    @include breakpoint(#{$bp-sm}px) {
      background: linear-gradient(to bottom, color-alpha($c-background, 0), $c-background, $c-background, $c-background);
    }
  }
}

.track-container {
  position: absolute;
  left: 50%;
  top: 65%;
  transform: translate(-50%, -50%);
  height: 30px;
  width: $concept-selector-mobile-track-percent + 10%;
  font-size: 14px;
  // border: 1px solid $c-black;
  @include breakpoint(#{$bp-sm}px) {
    top: 50%;
    width: $concept-selector-desktop-track-percent + 5%;
  }

  .track {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    border-top: 1px dotted #b1b1b1;
    height: 0;
  }

  .minus {
    position: absolute;
    left: -25px;
    top: 50%;
    transform: translate(0, -50%);
    color: #b1b1b1;
  }

  .plus {
    position: absolute;
    right: -25px;
    top: 50%;
    transform: translate(0, -50%);
    color: #b1b1b1;
  }
}

.desktop-intro,
.desktop-instructions {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: $c-gray;
  letter-spacing: 1px;
  line-height: 20px;
}

.definition {
  position: absolute;
  left: 0;
  bottom: 50%;
  transform: translate(0, -50%);
  color: $c-gray;
  text-align: center;
  letter-spacing: 1px;
  width: 100%;

  @include breakpoint(#{$bp-sm}px) {
    display: none;
  }
}

.cancel-btn {
  &:hover,
  &:focus {
    background: transparent;
    color: $c-gray;
    opacity: 0.6;
  }
}

.importance-enter-active,
.importance-leave-active {
  transition: opacity 0.5s;

  .title,
  .desktop-intro,
  .definition,
  .track-container,
  .cancel-btn,
  .confirm-btn {
    transition: opacity 0.5s;
  }

}

.importance-enter,
.importance-leave-to {
  opacity: 1;

  .title,
  .desktop-intro,
  .definition,
  .track-container,
  .cancel-btn,
  .confirm-btn {
    opacity: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/organisms/ConceptImportanceUI.vue